import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'build',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'build.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'Review pull requests that build against requirements',
    name: 'Build',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
